const styles = {
  container: {},

  sectionTitle: {
    marginBottom: 2
  },

  skeletonCard: {
    marginBottom: 3,
    borderRadius: 2
  },

  skeletonContent: {
    padding: 2
  },

  sideSection: {
    marginBottom: 3
  },

  contentContainer: {
    marginTop: 2
  },

  // The item a Locker Orders link pointed at. Marked, not animated: the page jumps straight to it.
  // The scroll margin keeps it clear of the dashboard's top bar.
  focusedItemRequest: {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: 4,
    borderRadius: 2,
    scrollMarginTop: 96
  },

  headerActionsContainer: {
    display: 'flex',
    gap: 1
  },

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: 1
  }
}

export default styles
